import React from "react";
import clsx from "clsx";

import { Button } from "components";

import { ReactComponent as CancelIcon } from "static/images/cancel.svg";
import { ReactComponent as CheckDone } from "static/images/checked.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "../tables.module.scss";

export const RowActions = ({
	onEditClick,
	onDeleteClick,
	onSaveClick,
	onHideEditRowClick,
	className,
}) =>
	(onEditClick || onDeleteClick || onSaveClick || onHideEditRowClick) && (
		<div className={clsx(className, styles.wrapActions)}>
			{onDeleteClick || onHideEditRowClick ? (
				<Button
					onClick={
						!onDeleteClick ? onHideEditRowClick : onDeleteClick
					}
					icon={<CancelIcon />}
					btnIcon
					variant="secondary-danger"
					size="sm"
					title={`${!onDeleteClick ? "HideEditRow" : "Delete"}`}
					style={{ marginRight: "15px" }}
				/>
			) : (
				""
			)}
			{onEditClick && (
				<Button
					onClick={onEditClick}
					icon={<EditIcon />}
					btnIcon
					variant="secondary"
					size="sm"
					title="Edit"
				/>
			)}
			{onSaveClick && (
				<Button
					onClick={onSaveClick}
					icon={<CheckDone />}
					btnIcon
					variant="secondary"
					size="sm"
					title="Save"
				/>
			)}
		</div>
	);
